import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import reducers from "./reducers"
import posthog from 'posthog-js'
import { PostHogProvider } from "posthog-js/react"
import { GoogleOAuthProvider } from "@react-oauth/google"
import App from "./App"

if (process.env.NODE_ENV === "production") {
  // Initialize posthog
  posthog.init(process.env.REACT_APP_POSTHOG_PROJECT_API_KEY,
    {
      api_host: process.env.REACT_APP_POSTHOG_API_HOST,
      capture_pageview: false,
      person_profiles: 'identified_only'
    }
  )
}

const store = createStore(reducers, compose(applyMiddleware(thunk)))

ReactDOM.render(
  <Provider store={store}>
    <PostHogProvider client={posthog}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    </PostHogProvider>
  </Provider>,
  document.getElementById("root"),
)